// extracted by mini-css-extract-plugin
module.exports = {"WrapperSeoLinksBlock":"SeoLinksBlock_WrapperSeoLinksBlock__MODrd","Title":"SeoLinksBlock_Title__zl3Aj"};